export default "__VITE_ASSET__DlFyLigr__"